module.exports = __webpack_public_path__ + "static/media/landing-slider-img-1.b40f6db3.jpg";